import { Story, Meta } from '@storybook/web-components';
import { html } from 'lit-html';
import './line-chart';

// More on default export: https://storybook.js.org/docs/web-components/writing-stories/introduction#default-export
export default {
  title: 'gsmlg/echarts/line',
  // More on argTypes: https://storybook.js.org/docs/web-components/api/argtypes
  argTypes: {},
} as Meta;

export interface ElementProps {
  width: string;
  height: string;
  loading: boolean;
  xKey: string;
  yKeys: string;
  yMin: number | string;
  yMax: number | string;
  data: object;
  smooth: boolean;
  showLegend: boolean;
  areaStyle: object | undefined;
}

// More on component templates: https://storybook.js.org/docs/web-components/writing-stories/introduction#using-args
const Template: Story<ElementProps> = ({
  width,
  height,
  loading,
  data,
  xKey,
  yKeys,
  yMin,
  yMax,
  smooth,
  showLegend,
  areaStyle,
}) =>
  html`<div style="width: ${width}; height: ${height};">
    <echarts-line
      ?loading=${loading}
      data=${JSON.stringify(data)}
      x-key=${xKey}
      y-keys=${yKeys}
      y-min=${yMin || 0}
      y-max=${yMax || 'auto'}
      value-suffix="%"
      ?smooth=${smooth}
      ?show-legend=${showLegend}
      area-style=${JSON.stringify(areaStyle)}
    ></echarts-line>
  </div>`;

export const Line = Template.bind({});

Line.args = {
  width: '100%',
  height: '480px',
  loading: false,
  xKey: 'name',
  yKeys: 'value',
  yMax: 'auto',
  data: [
    {
      name: '2018',
      value: 39,
    },
    {
      name: '2019',
      value: 68,
    },
    {
      name: '2020',
      value: 41,
    },
    {
      name: '2021',
      value: 102,
    },
    {
      name: '2022',
      value: 98,
    },
  ],
};

export const DataLine = Template.bind({});

DataLine.args = {
  width: '100%',
  height: '480px',
  loading: false,
  xKey: 'create_time',
  yKeys: 'cpu_usage_rate',
  yMin: 0,
  yMax: 100,
  data: [
    {
      cpu_usage_rate: 1.754978063512405,
      create_time: '2022-09-26T13:55:29.767457+08:00',
    },
    {
      cpu_usage_rate: 2.2957461178690055,
      create_time: '2022-09-26T13:55:24.756603+08:00',
    },
    {
      cpu_usage_rate: 1.8581081077785906,
      create_time: '2022-09-26T13:55:19.745937+08:00',
    },
    {
      cpu_usage_rate: 2.297297297354697,
      create_time: '2022-09-26T13:55:14.734795+08:00',
    },
    {
      cpu_usage_rate: 1.9932432430327773,
      create_time: '2022-09-26T13:55:09.724937+08:00',
    },
    {
      cpu_usage_rate: 2.1607022284669966,
      create_time: '2022-09-26T13:55:04.715171+08:00',
    },
    {
      cpu_usage_rate: 2.6608282268355703,
      create_time: '2022-09-26T13:55:00.00053+08:00',
    },
    {
      cpu_usage_rate: 1.7235552549769317,
      create_time: '2022-09-26T13:54:59.704995+08:00',
    },
    {
      cpu_usage_rate: 2.909336942658471,
      create_time: '2022-09-26T13:54:54.694325+08:00',
    },
    {
      cpu_usage_rate: 4.663737748298253,
      create_time: '2022-09-26T13:54:49.684534+08:00',
    },
    {
      cpu_usage_rate: 2.6422764225654443,
      create_time: '2022-09-26T13:54:44.673555+08:00',
    },
    {
      cpu_usage_rate: 2.7045300875369294,
      create_time: '2022-09-26T13:54:39.665788+08:00',
    },
    {
      cpu_usage_rate: 2.5693035836891682,
      create_time: '2022-09-26T13:54:34.656673+08:00',
    },
    {
      cpu_usage_rate: 2.703616085952896,
      create_time: '2022-09-26T13:54:29.647403+08:00',
    },
    {
      cpu_usage_rate: 2.8416779432207986,
      create_time: '2022-09-26T13:54:24.637158+08:00',
    },
    {
      cpu_usage_rate: 2.364066193148896,
      create_time: '2022-09-26T13:54:19.629434+08:00',
    },
    {
      cpu_usage_rate: 2.097428958260325,
      create_time: '2022-09-26T13:54:14.620283+08:00',
    },
    {
      cpu_usage_rate: 2.599594868630496,
      create_time: '2022-09-26T13:54:09.609429+08:00',
    },
    {
      cpu_usage_rate: 3.4064080942450503,
      create_time: '2022-09-26T13:54:04.598877+08:00',
    },
    {
      cpu_usage_rate: 2.8543482772600113,
      create_time: '2022-09-26T13:54:00.000693+08:00',
    },
    {
      cpu_usage_rate: 2.0945945939461894,
      create_time: '2022-09-26T13:53:59.588563+08:00',
    },
    {
      cpu_usage_rate: 2.498311952207412,
      create_time: '2022-09-26T13:53:54.577148+08:00',
    },
    {
      cpu_usage_rate: 2.4340770795537536,
      create_time: '2022-09-26T13:53:49.565991+08:00',
    },
    {
      cpu_usage_rate: 2.1628928693918015,
      create_time: '2022-09-26T13:53:44.55531+08:00',
    },
    { cpu_usage_rate: 3.17567567572032, create_time: '2022-09-26T13:53:39.545766+08:00' },
    {
      cpu_usage_rate: 1.9952654716315772,
      create_time: '2022-09-26T13:53:34.533413+08:00',
    },
    {
      cpu_usage_rate: 2.334235453526327,
      create_time: '2022-09-26T13:53:29.523283+08:00',
    },
    {
      cpu_usage_rate: 2.1643557656107686,
      create_time: '2022-09-26T13:53:24.511841+08:00',
    },
    {
      cpu_usage_rate: 4.976303317985671,
      create_time: '2022-09-26T13:53:19.501682+08:00',
    },
    {
      cpu_usage_rate: 4.194857917184135,
      create_time: '2022-09-26T13:53:14.492255+08:00',
    },
    {
      cpu_usage_rate: 2.706359945418221,
      create_time: '2022-09-26T13:53:09.481833+08:00',
    },
    { cpu_usage_rate: 2.39945927657754, create_time: '2022-09-26T13:53:04.472362+08:00' },
    {
      cpu_usage_rate: 2.5520655385935025,
      create_time: '2022-09-26T13:53:00.01501+08:00',
    },
    { cpu_usage_rate: 1.994590940336979, create_time: '2022-09-26T13:52:59.4622+08:00' },
    {
      cpu_usage_rate: 2.469553450969184,
      create_time: '2022-09-26T13:52:54.451759+08:00',
    },
    {
      cpu_usage_rate: 2.2696476963668855,
      create_time: '2022-09-26T13:52:49.442857+08:00',
    },
    {
      cpu_usage_rate: 3.085791794895037,
      create_time: '2022-09-26T13:52:44.433494+08:00',
    },
    {
      cpu_usage_rate: 2.130537707129885,
      create_time: '2022-09-26T13:52:39.422197+08:00',
    },
    {
      cpu_usage_rate: 4.871447901155076,
      create_time: '2022-09-26T13:52:34.410368+08:00',
    },
    {
      cpu_usage_rate: 2.1009827178555516,
      create_time: '2022-09-26T13:52:29.400728+08:00',
    },
    {
      cpu_usage_rate: 2.3350253811510155,
      create_time: '2022-09-26T13:52:24.391224+08:00',
    },
    {
      cpu_usage_rate: 2.1966880705006377,
      create_time: '2022-09-26T13:52:19.380568+08:00',
    },
    {
      cpu_usage_rate: 2.5059261766366876,
      create_time: '2022-09-26T13:52:14.371629+08:00',
    },
    {
      cpu_usage_rate: 2.5354969571633634,
      create_time: '2022-09-26T13:52:09.36443+08:00',
    },
    {
      cpu_usage_rate: 2.129097668961725,
      create_time: '2022-09-26T13:52:04.355229+08:00',
    },
    {
      cpu_usage_rate: 2.7471214917736355,
      create_time: '2022-09-26T13:52:00.000988+08:00',
    },
    {
      cpu_usage_rate: 2.1643557665498028,
      create_time: '2022-09-26T13:51:59.344401+08:00',
    },
    {
      cpu_usage_rate: 2.979011509923125,
      create_time: '2022-09-26T13:51:54.334289+08:00',
    },
    {
      cpu_usage_rate: 4.800540906449459,
      create_time: '2022-09-26T13:51:49.324005+08:00',
    },
    {
      cpu_usage_rate: 2.639593908324672,
      create_time: '2022-09-26T13:51:44.314082+08:00',
    },
    {
      cpu_usage_rate: 2.3656640758536223,
      create_time: '2022-09-26T13:51:39.304229+08:00',
    },
    {
      cpu_usage_rate: 1.8581081086395879,
      create_time: '2022-09-26T13:51:34.294855+08:00',
    },
    {
      cpu_usage_rate: 1.8618821934556444,
      create_time: '2022-09-26T13:51:29.285051+08:00',
    },
    { cpu_usage_rate: 2.096010818096935, create_time: '2022-09-26T13:51:24.27524+08:00' },
    {
      cpu_usage_rate: 2.636916835953656,
      create_time: '2022-09-26T13:51:19.265391+08:00',
    },
    {
      cpu_usage_rate: 2.0297699591621226,
      create_time: '2022-09-26T13:51:14.251891+08:00',
    },
    {
      cpu_usage_rate: 2.1269412551884566,
      create_time: '2022-09-26T13:51:09.242009+08:00',
    },
    {
      cpu_usage_rate: 4.1948579167903075,
      create_time: '2022-09-26T13:51:04.231532+08:00',
    },
    {
      cpu_usage_rate: 2.946450804397991,
      create_time: '2022-09-26T13:51:00.000899+08:00',
    },
    {
      cpu_usage_rate: 1.8224772194537813,
      create_time: '2022-09-26T13:50:59.22046+08:00',
    },
    {
      cpu_usage_rate: 2.398648648402042,
      create_time: '2022-09-26T13:50:54.210139+08:00',
    },
    {
      cpu_usage_rate: 1.8925312605211124,
      create_time: '2022-09-26T13:50:49.199161+08:00',
    },
    {
      cpu_usage_rate: 2.2619851459115328,
      create_time: '2022-09-26T13:50:44.188793+08:00',
    },
    {
      cpu_usage_rate: 1.858108108246293,
      create_time: '2022-09-26T13:50:39.176441+08:00',
    },
    {
      cpu_usage_rate: 2.096010819152817,
      create_time: '2022-09-26T13:50:34.166771+08:00',
    },
  ],
};

export const Smooth = Template.bind({});

Smooth.args = {
  width: '100%',
  height: '480px',
  loading: false,
  smooth: true,
  showLegend: true,
  xKey: 'name',
  yKeys: 'value',
  areaStyle: { color: 'cyan' },
  data: [
    {
      name: '2018',
      value: 39,
    },
    {
      name: '2019',
      value: 68,
    },
    {
      name: '2020',
      value: 41,
    },
    {
      name: '2021',
      value: 102,
    },
    {
      name: '2022',
      value: 98,
    },
  ],
};
